module.exports = __webpack_public_path__ + "img/web成功.3223ff28.png";